document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const isOpen = menu.hasAttribute('hidden') === false;
  if (isOpen) menu.setAttribute('hidden', '');
  else menu.removeAttribute('hidden');
  toggle.setAttribute('aria-expanded', String(!isOpen));
});

document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const container = select.closest('[data-product-form]');
  if (!container) return;
  const option = select.options[select.selectedIndex];
  const price = container.querySelector('[data-product-price]');
  const button = container.querySelector('[data-add-button]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  }
});